import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TablePagination from '@material-ui/core/TablePagination'
import Button from '@material-ui/core/Button'
import Popover from '@material-ui/core/Popover';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AddAlarmIcon from '@material-ui/icons/AddAlarm';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import PhoneMissedIcon from '@material-ui/icons/PhoneMissed';
import DeviceUnknownIcon from '@material-ui/icons/DeviceUnknown';
import { Grid } from '@material-ui/core';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Screenshot from '../../../../../helpers/Screenshot';

import { Timeline, TimelineEvent } from '@mailtop/horizontal-timeline'
import { FaBug, FaRegCalendarCheck, FaRegFileAlt, FaRegCheckCircle } from 'react-icons/fa'
import Tooltip from '@material-ui/core/Tooltip';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';


// Component styles
import styles from '../styles';
import { Paper } from '@material-ui/core';
import { api_host , api_auth} from '../../../../../common/globals/constants';
import { element } from 'prop-types';
import icons from '../../../../../theme/icons.js';
import { AtTimelineEvent } from '../../../../../components/AtTimeline/AtTimelineEvent';

const moment = require('moment');
class EventsTable extends Component {
    _currentObjectiveId = null;
    
    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId : this.props.match.params.objetivo_id,
            service: props.location.state.fromObjective.grupo_servicio_unificado,
            loadObjectiveData : false,
            actualUptime: 0,
            externalData: null,
            dataError: false,
            isLoading: true,
            time: props.params.period,
            totalCell: 2,
            StatePeriod: props.params.StatePeriod, 
            pages: 1,
            page: 0, 
            isOpen: false,
            target: null,
            currentNode: null,
            currentDate: null,
            monitores: props.location.state.fromObjective.Monitores,
            listCdn: []
        }
    }
    static getDerivedStateFromProps(nextProps, prevState){
        if (nextProps.match.params.objetivo_id !== prevState.prevObjectiveId) {
            return {
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                isLoading: true,
                dataError: false,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period !== prevState.time) {
            return {
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period === prevState.time && nextProps.params.statePeriod !== prevState.statePeriod) {
            return {
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: prevState.time,
                dataError: false,
                isLoading: true,
                statePeriod: nextProps.params.statePeriod,
            }
        }
        return null;
    }
    componentDidMount() {
        this.getDataFromAPI();
    }  

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {
            this.getDataFromAPI();
        }
    }
    getDataFromAPI = (objectiveId) => {
        const { time, statePeriod, currentObjectiveId } = this.state
        let token = sessionStorage.getItem('key')
        let id_user = sessionStorage.getItem('user')
        let finalTime = (moment().format('YYYY-MM-DD HH:mm'))
        let beginTime = (moment().subtract(1, "hours").format('YYYY-MM-DD HH:mm'))
        if (this.state.time === 'd') {
            beginTime = (moment().subtract(1, "days").format('YYYY-MM-DD HH:mm'))
        } else if (this.state.time === 'w') {
            beginTime = (moment().subtract(1, "weeks").format('YYYY-MM-DD HH:mm'))
        } else if (this.state.time === '3h') {
            beginTime = (moment().subtract(3, "hours").format('YYYY-MM-DD HH:mm'))
        } else if (this.state.time === '3d') {
            beginTime = (moment().subtract(3, "days").format('YYYY-MM-DD HH:mm'))
        }
        
        let fecha_inicio = beginTime
        let fecha_termino = finalTime

        if (time === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10) + " 00:00"
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10) + " 00:00"           
            fetch(api_host+`/reporte/online/eventos/Reporte3EventsExpanded/?user=${id_user}&key=${api_auth}&objetive=${currentObjectiveId}&datebegin=${fecha_inicio}&finaldate=${fecha_termino}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
                .then(response => response.json())
                .then(myJson => {
                    try {
                        this.processData(myJson)
                        
                    } catch (error) {
                        this.setState({
                            dataError: true,
                            data: null,
                            isLoading: false
                        });
                    }
                });
        } else {
            fetch(api_host+`/reporte/online/eventos/Reporte3EventsExpanded/?user=${id_user}&key=${api_auth}&objetive=${currentObjectiveId}&datebegin=${fecha_inicio}&finaldate=${fecha_termino}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
                .then( response => response.json())
                .then( myJson =>  {
                    try {
                        this.processData(myJson)
                        
                    } catch (error) {
                    this.setState({
                        dataError: true,
                        data: null,
                        isLoading: false
                    });
                }
            });
        }
    }

    getFetchs = (objective, begin, final, monitores, token) =>{
        return new Promise((resolve, reject) => {
            var cdnList = []
            var fetches = []            
            monitores.forEach((value, key)=>{
                var monitor_id=(value)
                var getListScreenshot = fetch(api_host+`/reporte/general/objetivos/${objective}/screenshots/list_images/?token=${token}&fecha_inicio=${begin}&fecha_termino=${final}&monitor=${monitor_id}`)
                        .then( response => response.json())
                fetches.push(                    
                    getListScreenshot.then( dataCdn =>  { 
                            cdnList[key] = dataCdn;
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(cdnList);
            })      
        });
    }

    processData = (externalData) => {
        const dataEvents  = externalData;
        var cell = -Infinity
        var pages = -Infinity
        Object(dataEvents).map(element=>{
            if(element.data_nodo.length > pages){
                pages = element.data_nodo.length
            }
            Object(element.data_nodo).map(element_nodo=>{
                if(element_nodo.length > pages){
                    cell = element_nodo.length
                }
            })
            
        })
     
        this.setState({
            externalData: dataEvents,
            totalCell: cell,
            pages: pages
        })
    }

    togglePopover = (event) => {
        const {monitores, currentObjectiveId, target} = this.state
        let token = sessionStorage.getItem('key')
        let beginTitle = String(event.currentTarget.id).substring(0,19)
        let endTitle = String(event.currentTarget.id).substring(19,38)
        let targetEvent = event.currentTarget
        let currentNode = event.currentTarget.value
        
        if (target !== event.currentTarget){
            var fetchListScreenshot = this.getFetchs(currentObjectiveId, beginTitle, endTitle, monitores, token)
            fetchListScreenshot.then( value =>{
                this.setState({ isOpen: !this.state.isOpen,
                                target: targetEvent,
                                currentDate: beginTitle,
                                currentNode: currentNode,
                                listCdn: value});
            })
        }
    };

    handleClose = () =>{
        this.setState({
            isOpen: false,
        })
    }

    setOpen = ( ele, tokenPicture, stepToken, dateBeginScreenshot, patternName) => {
        this.setState({
            modalOpen : true,
            modalClose : false,
            tokenPicture : tokenPicture,
            stepToken : stepToken,
            nameStep : ele,
            dateBeginScreenshot: dateBeginScreenshot,
            pattern: patternName
        })
    }

    createCell(data_nodo, total, id, target, currentDate, currentNode, monitor_id, isOpen){
        const {listCdn} = this.state
        var cells = []
        let codesOk = [0,9,14,17,30,200,204,301,304,307,602,1000]
        let codesOkString = ['0','9','14','17','30','200','204','301','304','307','602','1000']
        Object(data_nodo).map(element=>{
            let up = 0
            let down = 0
            let noMON = 0
            Object(element.pasos).map(({estado, patrones})=>{
                if (estado != null && estado.toString().includes(",")){
                    var split = estado.split(",")
                    let upPatterns = 0
                    let downPatterns = 0
                    Object(split).map(status=>{
                        if(codesOkString.includes(status)){
                            upPatterns = upPatterns + 1
                        }else{
                            downPatterns = downPatterns + 1
                        }  
                    })
                    if (downPatterns > 0) {
                        down = down + 1
                    } else {
                        up = up + 1
                    }
                } else if(estado == null){
                    let upPatterns = 0
                    let downPatterns = 0
                    let noMonPatterns = 0
                    Object(patrones).map(({estado})=>{
                        if(codesOk.includes(estado) || codesOkString.includes(estado)){
                            upPatterns = upPatterns + 1
                        }else if(estado === 'sin monitoreo'){
                            noMonPatterns = noMonPatterns + 1
                        }else{
                            downPatterns = downPatterns + 1
                        }
                    })
                    if (downPatterns > 0) {
                        down = down + 1
                    } else if (upPatterns > 0){
                        up = up + 1
                    } else if (noMonPatterns > 0){
                        noMON = noMON + 1
                    }
                }else {
                    if(codesOk.includes(parseInt(estado))){
                        up = up + 1
                    }else if(estado === 'sin monitoreo'){
                        noMON = noMON + 1
                    }else{
                        down = down + 1
                    }
                }
            })
            let status = 0
            if(noMON >= 1){
                status = 'sin monitoreo'
            }else if(down >= 1){
                status = 'downtime'
            }else{
                status = "uptime"
            }
            cells.push({"elementos": element, "estado": status})
        })
        let listFilteredScreenshot = []
        listCdn.map( monitor  => { 
            if (monitor.length > 0){
                monitor.map( registro => {
                    if (parseInt(registro.monitor_id) == monitor_id){
                        listFilteredScreenshot.push(registro)
                    }
                })
            }
        })
        let cont = 1
        return (<div>
                {cells.map( elements => {   
                    let listTokenDateFinal = []
                    let listTokenFinal = []
                    var disableButton = true
                    if (listFilteredScreenshot.length > 0) {
                        let eventBegin = new Date(elements.elementos.desde)
                        let eventEnd = new Date(elements.elementos.hasta)
                        listFilteredScreenshot.map( screen => {
                            let screenDate = new Date(screen.fecha_creacion.replace('T', ' '))
                            if ((eventBegin <= screenDate) && (screenDate < eventEnd)) {
                                listTokenFinal.push(screen.tokens)
                                    listTokenDateFinal.push(screen.fecha_creacion.replace('T', ' '))
                            }
                        })
                    }             
                var colorEvent = '#41B900'                      
                if(elements["estado"] === "sin monitoreo"){
                    colorEvent = ' #A9A9A9'
                }else if(elements["estado"] === "downtime"){
                    colorEvent = '#C2272D'
                }  

                if(target && (elements.elementos.desde === currentDate) && (parseInt(currentNode) === id)){
                    var steps = []
                    elements.elementos.pasos.map((step, key)=>{
                        var patternName = ''
                        if(typeof(step.patrones)!="undefined"){
                            step.estado='0'
                            step.patrones.map(patron=>{
                                patternName = patron.patron
                                if(!codesOk.includes(parseInt(patron.estado))){
                                    step.estado=String(patron.estado)
                                } 
                            })
                        }
                        if (step.estado.toString().includes(",")){
                            var split = step.estado.split(",")
                            var contDown = 0
                            var estado = "0"
                            Object(split).map(status=>{ 
                                if(!codesOkString.includes(parseInt(status))){
                                    contDown = contDown + 1 
                                    estado = status
                                }
                            })
                            if (contDown > 0){
                                step.estado = estado
                            } else {
                                step.estado = '0'
                            }
                        }
                        let token = 'NULL'
                        let date = null
                        listTokenFinal.map( (elements, index) => {   
                            if (elements[parseInt(step.id)] != 'NULL' && typeof(elements[parseInt(step.id)]) !== 'undefined'){
                                token = elements[parseInt(step.id)]
                                date = listTokenDateFinal[index]
                            }
                        })
                        var panorama = <Button onClick={(e)=>{this.setOpen(step.nombre_paso, token, parseInt(step.id), date, patternName)}}>
                                            <ImageOutlinedIcon style={{color:"white"}}/>
                                        </Button>
                        if (token === 'NULL' || typeof(token) === 'undefined'){
                            panorama = <div />
                        } 
                        var stepName = <TableCell>
                                            <Typography style={{color:"white"}}>
                                                <Grid
                                                    container
                                                    spacing={1}
                                                >
                                                    <Grid
                                                        item
                                                        xs={6}
                                                        sm={6}
                                                        md={6}
                                                        xl={6}
                                                    >
                                                        {step.nombre_paso}
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={6}
                                                        sm={6}
                                                        md={6}
                                                        xl={6}
                                                        style={{textAlign:'right'}}
                                                    >
                                                        {panorama}
                                                    </Grid>
                                                </Grid>
                                            </Typography>
                                        </TableCell>
                        var new_step = <Tooltip title="Periodo sin monitoreo" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)"}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteNO_MONITOREO}}/></Typography></TableCell></Tooltip>
                        if(codesOk.includes(parseInt(step.estado))){
                            new_step =<Tooltip title="OK" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteOK}}  /></Typography></TableCell></Tooltip>                                   
                        }else if(parseInt(step.estado)===27){
                            new_step = <Tooltip title="Timeout javascript" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteTIMEOUT_JS}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===13){
                            new_step = <Tooltip title="Error de contenido" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteERROR_CONTENIDO}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===1006){
                            new_step = <Tooltip title="Timeout de la operación del socket" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteTIMEOUT_DE_LA_OPERACION_DEL_SOCKET}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===3){
                            new_step = <Tooltip title="Timeout" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.sprite_TIMEOUT}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===500){
                            new_step = <Tooltip title="Error 500" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.sprite500}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===613){
                            new_step = <Tooltip title="Error de contenido" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteERROR_CONTENIDO}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===603){
                            new_step = <Tooltip title="Troncal ocupado" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteTRONCAL_OCUPADO}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===610){
                            new_step = <Tooltip title="Llamada colgada" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteLLAMADA_COLGADA}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===999999){
                            new_step = <Tooltip title="Error desconocido en script" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteERROR_DESCONOCIDO_EN_SCRIPT}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===607){
                            new_step = <Tooltip title="Timeout" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.sprite_TIMEOUT}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===601){
                            new_step = <Tooltip title="Troncal congestionado" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteTRONCAL_CONGESTIONADO}}/></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===404){
                            new_step = <Tooltip title="Error 404" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.sprite404}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado)===1004){
                            new_step = <Tooltip title="Timeout en Conexión" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteTIMEOUT_EN_CONEXION}}  /></Typography></TableCell></Tooltip>
                        }else if(parseInt(step.estado) == 503){
                            new_step = <Tooltip title="Error 503" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.sprite503}}  /></Typography></TableCell></Tooltip>
                        }else if(step.estado == 'sin monitoreo'){
                            new_step = <Tooltip title="Periodo sin monitoreo" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)"}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteNO_MONITOREO}}/></Typography></TableCell></Tooltip>
                        }else{
                            new_step = <Tooltip title="Error" placement="left"><TableCell style={{backgroundColor:"rgb(53, 53, 53)", textAlign:'center'}}><Typography style={{height:"50px", paddingLeft:'30px'}}><i style={{...icons.sprite, ...icons.spriteSIN_NOMBRE}}  /></Typography></TableCell></Tooltip>
                        }
                        
                        new_step=<TableRow>{stepName}{new_step}</TableRow>
                        steps.push(new_step)
                    })
                    
                }
                /*var duration = Math.trunc((new Date(elements.elementos.duracion).getTime() / (1000)) / 60)
      
                var msg = ''
                if (duration < 1) {
                    msg = msg+' hace pocos segundos'
                } else if (1 <= duration && duration < 60) {
                    msg = msg+' hace ' + duration + ' minuto(s)'
                } else if (60 <= duration && duration < 1440) {
                    var hour = Math.trunc(duration / 60)
                    var minute = duration - (60*hour)
                    msg = msg+' hace ' + hour + ' hora(s) con ' + minute + ' minuto(s)'
                } else if (1440 <= duration) {
                    msg = msg+' por más de 1 día'
                }*/
                var duration = elements.elementos.duracion.replace('day', 'día')
                return  <Button id={elements["elementos"]["desde"]+elements["elementos"]["hasta"]} value={id} style={{padding:"0px"}} onClick={this.togglePopover} /*onClose={this.handleClose}*/>
                            <AtTimelineEvent 
                                color={colorEvent}
                                title={elements.elementos.desde.substring(11,19)}
                                subtitle={elements.elementos.desde.substring(0,10)+'\n('+duration+')'}
                                titleProps={{color:"white"}}
                                subtitleProps={{color:"white", whiteSpace: 'pre-line'}}
                            />
                            {steps !== undefined ? <Popover
                                anchorEl = {target}
                                open={this.state.isOpen}
                                onClose={this.togglePopover} 
                                target={elements["elementos"]["desde"]+'-'+id}
                                anchorOrigin={{
                                    vertical: 'center',
                                    horizontal: 'center'
                                }}
                                transformOrigin={{
                                    vertical: 'center',
                                    horizontal: 'center'
                                }}><div><Table style={{backgroundColor:"rgb(53, 53, 53)", overflow:'hidden'}}>
                                            <TableHead> 
                                                <Typography variant="h3" style={{color:"white", paddingLeft:"10px"}}> Estado por paso</Typography>
                                            </TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography variant="h5" style={{color:"white"}}>Pasos</Typography>
                                                </TableCell>
                                                <TableCell style={{width:'130'}}>
                                                    <Typography variant="h5" style={{color:"white"}}>{currentDate.substring(11,19)}</Typography>
                                                    <Typography variant="h6" style={{color:"white"}}>{currentDate.substring(0,10)}</Typography>
                                                </TableCell>
                                            </TableRow>
                                            {steps}
                                        </Table>
                                    </div>
                            </Popover>
                            : null}
                            
                        </Button>
                                
                    })}
                </div>)
                                
    }

    createRow(arrayMap, pag, target, currentDate, currentNode, isOpen){
        const cellTotals = this.state.totalCell
        return (<div>
                    {arrayMap.map(({id, nombre_nodo, data_nodo, monitor_id})=>{     
                        if(data_nodo[pag]){           
                            return  <TableRow id={id} style={{height: 20 ,width:"800px", borderBottom: "1px solid white", }}>
                                        <TableCell style={{fontSize:"14px", borderBottom: "none", padding:"0px", textAlign:"center", width:200}} component="th" scope="row"> 
                                            <Typography style={{color:"white"}} variant="h4">{nombre_nodo}</Typography> 
                                        </TableCell>
                                        <TableCell style={{fontSize:"14px", borderBottom: "none", padding:"0px"}}>
                                            {this.createCell(data_nodo[pag], cellTotals, id, target, currentDate, currentNode, monitor_id, isOpen)}                                                
                                        </TableCell>
                                    </TableRow>
                        }
                    })}
                </div>)
    }

    handleChangePage = (e, page)=>{
        this.setState({
            page : page
        })
    }

    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true
        })
    }
    
    
    render() {
        const {pages, page, target, currentDate, currentNode, externalData, dataError, modalOpen, isOpen}=this.state
        const { classes, className, match } = this.props;
        const rootClassName = classNames(classes.root, className);
        if (externalData !== null && !dataError )  {
            const row = this.createRow(externalData, page, target, currentDate, currentNode, isOpen)
            return(               
                    <Table style={{backgroundColor:"#656565"}}>
                        {/*<TableRow>
                            <TableCell>{match.params.nombre_objetivo}</TableCell>
                        </TableRow>*/}
                        {row}
                        <TablePagination
                            style={{color:"white"}}
                            rowsPerPageOptions={[5]}
                            component="div"
                            count={8*pages}
                            rowsPerPage={8}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'previous page',
                                'style': {'color': 'white'}
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'next page',
                                'style': {'color': 'white'}
                            }}
                            onChangePage={this.handleChangePage}
                            labelDisplayedRows={
                                ({ from, to, count }) => {
                                  return `${from} - ${to} de ${count}`
                                }
                            }
                        />
                        <Modal
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={modalOpen}
                            onClose={this.setCloseModal}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 100,
                            }}               
                        >
                            <Fade in={modalOpen}>
                                <Screenshot data = {this.state}  onClose={this.setCloseModal}/>
                            </Fade>
                        </Modal>
                    </Table>
            )
        }else{
            return ( 

                <Portlet
                    /*  {...rest} */
                      //className={rootClassName}
                      style={{backgroundColor:"#656565"}}
                    >
                    {/*<PortletHeader className={classes.header}>
                        <PortletLabel 
                            variant="h6"
                            title={this.props.title}
                        />
                    </PortletHeader>*/}
                        <PortletContent>   
                                <Typography
                                    variant="h5">
                                    <CircularProgress
                                        variant="indeterminate"      
                                        size={24}
                                        thickness={4}                            
                                    />
                                    Cargando Información...
                                </Typography>     
                    </PortletContent>
                </Portlet>)        
        }
    }
}

export default 
compose(
  withRouter,
  withStyles(styles)

)(EventsTable);